// TODO: this should be refactored sooner than later
(function() {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairRegistrationController', PhysicalFairRegistrationController);

    /* @ngInject */
    function PhysicalFairRegistrationController($q, $filter, $scope, $state, $stateParams, $http, API_BASE, $uibModal, currencyFormatFilter, toastr, expos, PhysicalFairService) {
        /* Initializing view */
        var vm = ((...deps) => {
            vm = this;
            for (let dep of deps) dep();
            return vm;
        })(form, ui, log);    


        function log(log) {
            console.log(log)
        } 
        
        /* Prepare form data */
        function form() {
            vm.optionsDatepicker = {
                format: "longDate",
                autoUpdateInput: true,
                singleDatePicker: true, 
                showDropdowns: true,
            };            
            vm.seminarLangs = [
                {
                    id: 1,
                    name: 'English'
                },
                {
                    id: 2,
                    name: 'Português (Brasil)'
                },
                {
                    id: 3,
                    name: 'Español'
                },
                {
                    id: 4,
                    name: 'Italiano'
                },
                {
                    id: 5,
                    name: 'Català'
                },
                {
                    id: 6,
                    name: 'Français'
                }
            ];
            vm.isSchoolVisit = false;
            vm.expos = new Expos(expos);
            expos = undefined;
        }
      
        /* User Interface functionality */
        function ui() {
            /* Bindables */
            vm.save = save;
            vm.maxcharcount = 1000;
            vm.triggerUpload = triggerUpload;
            vm.handleUpload = handleUpload;
            vm.seeAllEvents = seeAllEvents;
            vm.toggleTour = toggleTour;
            vm.toggleAllInclusive = toggleAllInclusive;
            vm.validateAllInclusive = validateAllInclusive;
            vm.showValidateBt = false;
            vm.validateForm = validateForm;
            vm.roomTypePopoverIsOpen = {};
            vm.universities = [];
            
            var promises = [];

            if ($stateParams.hasOwnProperty('showValidateBt') && $stateParams.showValidateBt != undefined) {                         
                vm.showValidateBt = true;
            } 

            if (vm.pr_conflict) {
                alert('Pre-registration not loaded because the selected user is already enrolled in the fair. This may happen if the user pre-registered more than once in the same fair.\n\nGo back to leave as it is; or\n\nProceed by saving the form to also link this pre-registration to the user.');
            } 
            
            function triggerUpload(id) {
                angular.element('#'+id).trigger('click');
            }

            function handleUpload(rep) {
                promises.push($q((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        rep.passportImage = reader.result;
                        resolve();
                    }
                    reader.onerror = error => reject(error);
                    reader.readAsDataURL(rep.passportImage);
                }));
            }

            function seeAllEvents() {
                vm.expos.expos.map(expo => expo.show_in_form = true);
            }

            vm.groupedLocations = [];

            function toggleTour(tour) {      
                
                if (!tour.selected) {      
                    if(tour.representatives.tour.grouped) {
                        delete vm.groupedLocations[tour.representatives.tour.grouped];
                    }  
                    delete tour.booth;
                    tour.optionals.map(opt => opt.selected = false);                    
                } else {
                    if(tour.representatives.tour.grouped) {
                        vm.groupedLocations[tour.representatives.tour.grouped] = tour.id;
                    }  

                    tour.booth = tour.booths[0];
                }

                // console.log(tour);
            }

            function toggleAllInclusive(expo) {
                expo.tours.forEach(tour => {   
                    var selectTour = true;
                    if (expo.full_tour_pack.locations.length > 0) {
                        selectTour = !!$filter('filter')(expo.full_tour_pack.locations, {id: tour.id})[0];                        
                    }                 
                    tour.selected = (!!expo.full_tour_pack && selectTour);
                    expo.show_accommodations = !!expo.full_tour_pack.accommodation_included;
                    expo.show_transportations = !!expo.full_tour_pack.transportation_included;
                    toggleTour(tour);
                });
            }

            function validateAllInclusive() {
                return !vm.expos.expos.filter(expo => expo.full_tour_pack && expo.full_tour_pack.accommodation_included && !!expo.tours.filter(tour => !!$filter('filter')(expo.full_tour_pack.locations, {id: tour.id})[0] && !!tour.accommodations.filter(accom => !accom.rooms.rooms.filter(room => !room.deleted).length).length).length).length;
            }

            function save() {
                var params = {};
                let data = vm.universities;                
                vm.saving = true;

                if ($stateParams.prId) {
                    params.pr_id = $stateParams.prId
                }
                data['universities'] = vm.universities;
                data['user_id'] = $stateParams.userId;

                expos = prepareData();
                $q.all(promises)
                .then(() => {
                    $http({
                        method: 'POST',
                        url: API_BASE + '/physicalfairs/pre-registrations/registration/' + $stateParams.userId,
                        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
                        params,
                        data: {
                            expos
                        },
                    }).then(function (res) {
                        $http({
                            method: 'POST',
                            url: API_BASE + '/physicalfairs/pre-registrations/registration-communities/' + $stateParams.userId,
                            headers: { 'Content-Type': 'application/json; charset=UTF-8' },
                            params,
                            data: {
                                data
                            },
                        }).then(function (res) {
                            toastr.success('Registration successfully saved.');
                            $state.go('root.physicalfairs.preRegistrations', null, {reload:true});
                        }).catch(function(res) {
                            console.log(res);
                        });
                    }).catch(function (res) {
                        var code = res.data.message && res.data.message.split(':')[0] || undefined;
                        switch (code) {
                            case 'invalid-image-format':
                                toastr.error('Invalid image format. Accepted formats are jpg, png, bmp, gif.');
                                break;
                            case 'sold-out':
                                toastr.error(res.data.message.split(':')[1]);
                                break;
                            default:
                                var encodedErr = btoa(JSON.stringify(res.data || 'empty response'));
                                toastr.error('Something is not right. Please check the data entered and try again.<br><br>If you think something is wrong, <a onclick="copyText(\''+encodedErr+'\')"><b>click here</b></a> to copy the error details and report back to the development team.', {
                                    allowHtml: true,
                                    timeOut: 10000,
                                });
                                break;
                        }
                    }).finally(() => vm.saving = false);
                });
            }

            function prepareData() {
                var expos = angular.copy(vm.expos.expos);
                return expos.filter(expo => !!(expo.full_tour_pack || expo.full_tour_packs.expo_user_full_tour_pack_id) || !!expo.expos_users_id || !!expo.tours.filter(tour => !!tour.booth).length)
                    .map(expo => {
                        expo.full_tour_packs = expo.full_tour_packs.map(full_tour_pack => {
                            full_tour_pack.selected = expo.full_tour_pack && full_tour_pack.id == expo.full_tour_pack.id;
                            return full_tour_pack;
                        });
                        delete expo.full_tour_pack;
                        expo.sponsors = expo.sponsors.filter(sponsor => !!sponsor.expos_users_sponsors_id || sponsor.selected);
                        expo.transportations = expo.transportations.filter(trans => !!trans.expos_users_transportations_id || trans.selected)
                            .map(trans => {
                                trans.passengers = trans.passengers.passengers;
                                return trans;
                            });
                        expo.tours = expo.tours.filter(tour => !!tour.expos_users_locations_id || !!tour.booth)
                            .map(tour => {
                                tour.seminars = tour.seminars.filter(seminar => seminar.expos_users_seminars_id || seminar.selected)
                                    .map(seminar => {
                                        seminar.details = {
                                            title: seminar.details.title || '',
                                            description: seminar.details.description || '',
                                            language_id: seminar.details.language && seminar.details.language.id || '',
                                        }
                                        return seminar;
                                    }); 
                                tour.accommodations = tour.accommodations.filter(accom => !!accom.rooms.rooms.length)
                                    .reduce((rooms, accom) => {
                                        accom.rooms.rooms.map(room => {
                                            room.checkin = moment(room.checkin, 'YYYY-MM-DD', true).isValid() ? moment(room.checkin).format('YYYY-MM-DD') : '';
                                            room.checkout = moment(room.checkout, 'YYYY-MM-DD', true).isValid() ? moment(room.checkout).format('YYYY-MM-DD') : '';
                                            return room;
                                        });

                                        return rooms.concat(accom.rooms.rooms);
                                    },[]);
                                tour.representatives = tour.representatives.reps
                                    .filter(rep => Object.keys(rep).length);
                                tour.optionals = tour.optionals.reduce((acc, curr) => {
                                    acc[curr.value] = curr.selected;
                                    return acc;
                                },{}); 
                                delete tour.booths;
                                delete tour.expo;
                                // debugger;
                                return tour;
                            });                        

                        return expo;
                    });
            } 

            // TODO:
            window.copyText = window.copyText || function(text) {
                var tmp = $("<input>");
                $('body').append(tmp);
                tmp.val(text).select();
                document.execCommand('copy');
                tmp.remove();
            }  
        }

        /* Expos */
        function Expos(expos) {
            var instance = {
                getFasciaNames(search) {
                    var names = instance.expos.reduce((names, expo) => names.concat(expo.tours.map(tour => tour.fascia_name)), [])
                        .filter((name, index, names) => name && names.indexOf(name) == index);
                    if (search && names.indexOf(search) === -1) {
                        names.unshift(search);
                    } 
                    return names;
                },                                                
                searchRepresentatives(search) {
                    var reps = instance.representatives;
                    if (search && reps.map(rep => rep.name).indexOf(search) === -1) {
                        reps.unshift({name: search});
                    } 
                    return reps;
                },
                updateRepresentatives(rep, model) {
                    if (rep && model) {                        
                        model.name = rep.name;                        
                        model.email = rep.email;
                    }
                    instance.representatives = instance.expos.reduce((names, expo) => names.concat(expo.tours.map(tour => tour.representatives.reps.filter(rep => rep.name && !!rep.name.length)).filter(tour => !!tour.length)), [])
                        .reduce((reps, rep) => reps.concat(rep), [])
                        .filter((rep, index, reps) => reps.map(rep => `${rep.name} ${rep.email}`).indexOf(`${rep.name} ${rep.email}`) == index);
                },
                representatives: [],
                contacts: [],
            };

            (function constructor() {
                instance.expos = expos.map(expo => {  
                    
                    if (expo.is_school_visit) {
                        vm.isSchoolVisit = true;
                    }                       
                    expo = {
                        expo_id: expo.id,
                        expos_users_id: !!expo.users.length && expo.users[0].id,
                        name: expo.name,
                        currency: expo.currency,
                        invoiced: expo.users.length ? (expo.users[0].status == 'invoice_created' ? true : false) : undefined,
                        is_school_visit: expo.is_school_visit,
                        full_tour_packs: expo.full_tour_packs,
                        exhibitor_partner: expo.pre_registrations.length && expo.pre_registrations[0].partner ? expo.pre_registrations[0].partner.toLowerCase() : (expo.users.length && expo.users[0].partner ? expo.users[0].partner : undefined),
                        exclusive_for_partner: expo.full_tour_packs.length && expo.full_tour_packs[0].exclusive_for_partner ? expo.full_tour_packs[0].exclusive_for_partner.toLowerCase() : undefined,
                        comments: expo.users.length && expo.users[0].comments || '',   
                        contact_name: (expo.users.length && expo.users[0].contact_name) ? expo.users[0].contact_name : '',                        
                        contact_email: (expo.users.length && expo.users[0].contact_email) ? expo.users[0].contact_email : '',  
                        pr_opportunities: expo.users.length && expo.users[0].public_relations_opportunity || '',
                        show_in_form: !!(expo.users.length || expo.pre_registrations.length),
                        show_accommodations: true,
                        show_transportations: true,
                        transportations: expo.transportations.map(transportation => ({
                            id: transportation.id,
                            leg: transportation.leg,                            
                            itinerary: transportation.itinerary,
                            observation: transportation.observation,
                            price: transportation.rate,
                            date: moment(transportation.date).format('MMM D, YYYY'),
                            expos_users_transportations_id: !!(transportation.expos_users_transportations && !!transportation.expos_users_transportations.length) && transportation.expos_users_transportations[0].id,
                            selected: transportation.expos_users_transportations && !!transportation.expos_users_transportations.length,
                            passengers: new Passenger(transportation)
                        })),
                        sponsors: expo.sponsors.map(sponsor => ({
                            id: sponsor.id,
                            type: sponsor.type,
                            name: sponsor.expo_sponsor_type && sponsor.expo_sponsor_type.name,
                            price: sponsor.rate,
                            remaining: sponsor.remaining,
                            description: sponsor.description,
                            expos_users_sponsors_id: !!(sponsor.expos_users_sponsors && !!sponsor.expos_users_sponsors.length) && sponsor.expos_users_sponsors[0].id,
                            selected: sponsor.expos_users_sponsors && !!sponsor.expos_users_sponsors.length
                        })), 
                        tours: expo.locations.map(tour => new Tour(tour, expo)),
                    };

                    expo.full_tour_packs = expo.full_tour_packs.map(full_tour_pack => {
                        const has_prereg = full_tour_pack.pre_registrations && full_tour_pack.pre_registrations.length;

                        full_tour_pack = {                            
                            title: full_tour_pack.title,
                            id: full_tour_pack.id,
                            accommodation_included: !!full_tour_pack.accommodation_included,
                            transportation_included: !!full_tour_pack.transportation_included,
                            expo_user_full_tour_pack_id: full_tour_pack.expos_users_full_tour_pack && full_tour_pack.expos_users_full_tour_pack.length ? full_tour_pack.expos_users_full_tour_pack[0].id : undefined,                            
                            booths_price: moment().startOf('day').isAfter(full_tour_pack.standard_rate_date) ? full_tour_pack.booths_late_rate : full_tour_pack.booths_standard_rate,
                            other_costs: moment().isAfter(full_tour_pack.standard_rate_date) ? full_tour_pack.other_costs_late_rate : full_tour_pack.other_costs_standard_rate,
                            total_price: moment().isAfter(full_tour_pack.standard_rate_date) ? (parseFloat(full_tour_pack.booths_late_rate) + parseFloat(full_tour_pack.other_costs_late_rate)) : (parseFloat(full_tour_pack.booths_standard_rate) + parseFloat(full_tour_pack.other_costs_standard_rate)),
                            locations: full_tour_pack.locations.map(location => ({ id: location.expo_location_id })),
                        };

                        var conflict = !!($stateParams.prId && expo.pre_registrations && expo.pre_registrations.length && expo.users.length);
                        vm.pr_conflict = vm.pr_conflict || conflict;

                        if (full_tour_pack.expo_user_full_tour_pack_id || (!vm.pr_conflict && has_prereg)) {
                            expo.full_tour_pack = full_tour_pack;
                        }

                        expo.show_full_tour_packs = ((expo.exclusive_for_partner == undefined) || (expo.exhibitor_partner == expo.exclusive_for_partner));                        

                        if ((expo.exclusive_for_partner != undefined) && (expo.exhibitor_partner == undefined)) {
                            // expo.show_accommodations = false;
                            // expo.show_transportations = false;
                        } else {
                            expo.show_accommodations = !!full_tour_pack.accommodation_included;
                            expo.show_transportations = !!full_tour_pack.transportation_included;
                        }

                        return full_tour_pack;
                    });

                    return expo;
                });

                instance.updateRepresentatives();
            })();

            return instance;
        }

        /* Tour */
        function Tour(tour, expo) {
            var instance = {};

            (function constructor() {
                vm.pr_conflict = vm.pr_conflict || !!($stateParams.prId && tour.pre_registrations.length && expo.users.length);
                instance.id = tour.id;
                instance.remaining = tour.remaining;
                instance.expo = expo;               
                instance.is_school_visit = !!(expo.is_school_visit == 1 || tour.is_high_school_road_show == 1);
                instance.is_university_visit = tour.is_university_visit;
                instance.expos_users_locations_id = !!(tour.expos_users_locations && tour.expos_users_locations.length) && tour.expos_users_locations[0].id;
                instance.sold_out = ((tour.sold_out == 1) || (tour.remaining <= 0));

                var selectTour = true;
                if ((typeof expo.full_tour_pack != 'undefined') && (expo.full_tour_pack.locations.length > 0)) {
                    selectTour = !!$filter('filter')(expo.full_tour_pack.locations, {id: tour.id})[0];                        
                }                
                instance.selected = !!(
                    !!(typeof tour.expos_users_locations !== 'undefined' && tour.expos_users_locations.length) || 
                    !!(!instance.sold_out && !vm.pr_conflict && $stateParams.prId && tour.pre_registrations.length) || 
                    !!(expo.pre_registrations.length && expo.pre_registrations[0].all_inclusive == 1) || 
                    !!(typeof expo.full_tour_pack !== 'undefined' && typeof expo.full_tour_pack.expos_users_full_tour_pack !== 'undefined' && expo.full_tour_pack.expos_users_full_tour_pack.length && selectTour)
                    );

                if (instance.selected) {
                    instance.booth = tour.booths[0];
                }

                instance.already_registered = instance.selected;

                instance.canceled = !!(tour.canceled == 1);
                
                if(tour.address) {
                    instance.city = tour.address.cities.city_name;
                }

                var date = tour.dates[0] ? moment(tour.dates[0].date).format('MMMM D') : '';
                if ((date != '') && (tour.dates.length >= 2)) {
                    if (tour.dates.length == 2) {
                        date += ' / ';
                    } else if (tour.dates.length > 2) {
                        date += ' - ';
                    } 
                    date += moment(tour.dates[tour.dates.length - 1].date).format('MMMM D');
                }
                instance.date = date;
                instance.original_date = tour.dates[0] ? tour.dates[0].date : '';
                instance.booths = tour.booths.map(booth => {
                    booth = {
                        id: booth.id,
                        size: booth.type,
                        price: moment().startOf('day').isAfter(booth.standard_rate_date) ? booth.late_rate : booth.standard_rate,
                    };
                    if ((tour.expos_users_locations && tour.expos_users_locations[0] && booth.id == tour.expos_users_locations[0].expo_booth_id) || (!vm.pr_conflict && $stateParams.prId && tour.pre_registrations.length && booth.id == tour.pre_registrations[0].pivot.expo_booth_id)) {
                        instance.booth = booth;
                    }
                    return booth;
                });
                instance.fascia_name = (tour.expos_users_locations && tour.expos_users_locations[0]) ? tour.expos_users_locations[0].fascia_name : undefined;
                instance.representatives = new Representative(tour);
                instance.optionals = (() => {
                    var opts = [];
                    
                    expo.offer_assistants != 0 && opts.push({ 
                        name: 'Translator - ' + currencyFormatFilter(expo.assistante_rate, expo.currency) + '/day',
                        value: 'assistante',
                        selected: !!((tour.expos_users_locations && tour.expos_users_locations[0] && tour.expos_users_locations[0].assistante==1) || (!vm.pr_conflict && $stateParams.prId && tour.pre_registrations.length && tour.pre_registrations[0].pivot.assistante==1)),
                    });
                    tour.has_premium != 0 && opts.push({ 
                        name: 'Premium Location',
                        value: 'premium',
                        selected: !!((tour.expos_users_locations && tour.expos_users_locations[0] && tour.expos_users_locations[0].premium) || (!vm.pr_conflict && $stateParams.prId && tour.pre_registrations.length && tour.pre_registrations[0].pivot.premium)),
                    });
                    tour.has_matchmaking_session != 0 && opts.push({ 
                        name: 'Business Matchmaking',
                        value: 'matchmaking_session',
                        selected: !!((tour.expos_users_locations && tour.expos_users_locations[0] && tour.expos_users_locations[0].matchmaking_session) || (!vm.pr_conflict && $stateParams.prId && tour.pre_registrations.length && tour.pre_registrations[0].pivot.matchmaking_session)),
                    });
                    
                    return opts;
                })();
                instance.seminars = tour.dates.reduce((seminars, date) => 
                    seminars.concat(date.seminars.map(seminar => ({
                        id: seminar.id,
                        date: moment(date.date).format('MMMM D'),
                        start_time: seminar.start_time,
                        end_time: seminar.end_time,
                        blocked: seminar.blocked,
                        blocked_by: seminar.blocked_by,
                        expos_users_seminars_id: !!seminar.users.length && seminar.users[0].user_id == $stateParams.userId && seminar.users[0].pivot.id,
                        selected: seminar.users.length && seminar.users[0].user_id == $stateParams.userId,
                        can_edit: seminar.users.length && seminar.users[0].user_id == $stateParams.userId || !seminar.users.length,
                        details: seminar.users.length && {
                            title: seminar.users[0].pivot.title,
                            description: seminar.users[0].pivot.description,
                            language: vm.seminarLangs[seminar.users[0].pivot.native_Language_id-1],
                        }
                    }))), []);
                instance.accommodations = tour.accommodations.map(accom => ({
                    id: accom.id,
                    name: accom.address && accom.address.name,
                    event_venue: accom.event_venue,
                    rate: accom.single_room_rate,
                    double_rate: accom.double_room_rate,
                    checkin: moment(accom.checkin, 'YYYY-MM-DD', true).isValid() ? accom.checkin : undefined,
                    checkout: moment(accom.checkout, 'YYYY-MM-DD', true).isValid() ? accom.checkout : undefined,
                    rooms: new Room(accom),
                }));
            })();

            return instance;
        }

        /* Representatives */
        function Representative(tour) {
            var instance = {
                tour: tour,
                reps: [],
                getList: () => instance.reps,
                add(rep = {}) { 
                    instance.reps.push(rep) 
                },    
                remove(index) {
                    if (instance.reps[index].id) {
                        instance.reps[index].deleted = true;
                    } else {
                        instance.reps.splice(index,1);
                    }
                },
            };

            (function constructor() {
                if (tour.expos_users_locations && !!tour.expos_users_locations.length && !!tour.expos_users_locations[0].representatives.length) {
                    tour.expos_users_locations[0].representatives.map(rep => {
                        instance.add({
                            id: rep.id,
                            name: rep.name,
                            email: rep.email,                            
                        });
                    });
                } else {
                    instance.add();
                }
            })();

            return instance;
        }       

        /* Passengers */
        function Passenger(transportation) {
            var instance = {
                transportation: transportation,
                passengers: [],
                getList: () => instance.passengers,
                add(passenger = {}) { 
                    instance.passengers.push(passenger) 
                },    
                remove(index) { 
                    if (instance.passengers[index].id) {
                        instance.passengers[index].deleted = true;
                    } else {
                        instance.passengers.splice(index,1);
                    }
                },
            };

            (function constructor() {
                if (transportation.expos_users_transportations && !!transportation.expos_users_transportations.length) {
                    transportation.expos_users_transportations[0].representatives.map(rep => {
                        instance.add({
                            id: rep.id,
                            name: rep.name,
                            passport: rep.passport,
                            email: rep.email,
                            birthday: rep.date_of_birth
                        });
                    });
                } else {
                    instance.add();
                }
            })();

            return instance;
        }

        /* Rooms */
        function Room(accommodation) {
            var instance = {
                accommodation: accommodation,
                rooms: [],
                getList: () => instance.rooms,
                add(room = {}) { 
                    if (typeof room === 'string') {
                        instance.rooms.push({
                            expo_accommodation_id: accommodation.id,
                            rate: room == 'double' ? accommodation.double_room_rate : accommodation.single_room_rate,
                            checkin: moment(accommodation.checkin, 'YYYY-MM-DD', true).isValid() ? accommodation.checkin : undefined,
                            checkout: moment(accommodation.checkout, 'YYYY-MM-DD', true).isValid() ? accommodation.checkout : undefined,
                            type: room
                        }); 
                    } else {
                        instance.rooms.push(room);
                    } 
                },    
                remove(index) {
                    if (instance.rooms[index].id) {
                        instance.rooms[index].deleted = true;
                    } else {
                        instance.rooms.splice(index,1);
                    }
                },
            };

            (function constructor() {
                if (accommodation.expos_users_accommodations && !!accommodation.expos_users_accommodations.length) {
                    accommodation.expos_users_accommodations.map(room => {
                        instance.add({
                            id: room.id,
                            expo_accommodation_id: room.expo_accommodation_id,
                            rate: room.rate,
                            checkin: moment(room.checkin, 'YYYY-MM-DD', true).isValid() ? room.checkin : undefined,
                            checkout: moment(room.checkout, 'YYYY-MM-DD', true).isValid() ? room.checkout : undefined,
                            type: room.room_type,
                            g1id: room.guests && room.guests[0] && room.guests[0].id,
                            g1name: room.guests && room.guests[0] && room.guests[0].name,
                            g1surname: room.guests && room.guests[0] && room.guests[0].surname,
                            g1email: room.guests && room.guests[0] && room.guests[0].email,
                            g2id: room.guests && room.guests[1] && room.guests[1].id,
                            g2name: room.guests && room.guests[1] && room.guests[1].name,
                            g2surname: room.guests && room.guests[1] && room.guests[1].surname,
                            g2email: room.guests && room.guests[1] && room.guests[1].email,
                        });
                    });
                }
            })();

            return instance;
        }        

        function validateForm() {          
            console.log(vm.form.$error);
            console.log(vm.validateAllInclusive());
        }
        
        function activate () {
            PhysicalFairService.getCommunitiesCollege($stateParams.userId)
            .then(function (res) {
                let data = [];
                data = res.data.map(function(item) {
                    vm.universities.push(item['university_name']);
                });
                //console.log(vm.universities);
            })
        }
        
        activate();
    }
})();
